var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modelframe',{attrs:{"message":_vm.message}},[_c('my-table',{attrs:{"data":_vm.roleList,"count":_vm.roleList.length,"limit":-1,"column-set":_vm.columnSet}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }